import type { AxiosResponse } from 'axios';
import type { StripeAccountStatus, StripeAccountSession } from '@app-types/models/finance';
import api from './api';

interface ConnectedAccountResponse {
  accountId: string;
  [key: string]: unknown;
}

interface StripeAccountLinkResponse {
  url: string;
  [key: string]: unknown;
}

interface DeleteStripeAccountResponse {
  success: boolean;
  [key: string]: unknown;
}

export const createConnectedAccount = async (businessId: string): Promise<ConnectedAccountResponse> => {
  try {
    const response: AxiosResponse<ConnectedAccountResponse> = await api.post('/business/create-connected-account', { businessId });
    return response.data;
  } catch (error: unknown) {
    console.error('Error creating connected account:', error);
    throw new Error('Failed to create connected account');
  }
};

export const getStripeAccountStatus = async (businessId: string): Promise<StripeAccountStatus> => {
  try {
    const response: AxiosResponse<StripeAccountStatus> = await api.get(`/business/stripe-account-status?businessId=${businessId}`);
    return response.data;
  } catch (error: unknown) {
    console.error('Error fetching Stripe account status:', error);
    throw new Error('Failed to fetch Stripe account status');
  }
};

export const getStripeAccountLink = async (type: string, businessId: string, returnURL: string, refreshURL: string): Promise<StripeAccountLinkResponse> => {
  try {
    const response: AxiosResponse<StripeAccountLinkResponse> = await api.post('/business/stripe-account-link', { type, businessId, returnURL, refreshURL });
    return response.data;
  } catch (error: unknown) {
    console.error('Error creating Stripe link:', error);
    throw new Error('Failed to create Stripe link');
  }
};

export const deleteStripeAccount = async (businessId: string): Promise<DeleteStripeAccountResponse> => {
  try {
    const response: AxiosResponse<DeleteStripeAccountResponse> = await api.get('/business/del-stripe-account?businessId='+ businessId);
    return response.data;
  } catch (error: unknown) {
    console.error('Error deleting Stripe account:', error);
    throw new Error('Failed to delete Stripe account');
  }
};

export const createAccountSession = async (): Promise<StripeAccountSession> => {
  try {
    const response: AxiosResponse<StripeAccountSession> = await api.post('/business/create-account-session');
    return response.data;
  } catch (error: unknown) {
    console.error('Error creating account session:', error);
    throw new Error('Failed to create account session');
  }
};
